// import { Logo } from '@/components/logo'

import Image from "next/image";
import Link from "next/link";

const links = [
  {
    group: "Product",
    items: [
      {
        title: "Platform",
        href: "/#platform",
      },
      {
        title: "Pricing",
        href: "/pricing",
      },
      {
        title: "Book a demo",
        href: "/book-a-demo",
      },
    ],
  },
  {
    group: "Solutions",
    items: [
      {
        title: "For Agencies",
        href: "/for-agencies",
      },
      {
        title: "Affiliate program",
        href: "https://promptwatch.tolt.io/",
      },
      {
        title: "Enterprise",
        href: "/book-a-demo",
      },
      // {
      //   title: "Contact Us",
      //   href: "/contact-us",
      // },
    ],
  },
  {
    group: "Free Tools",
    items: [
      {
        title: "All free tools",
        href: "/free-tools",
      },
      {
        title: "AI Brand Visibility Report",
        href: "/free-tools/ai-brand-visibility-report",
      },
      {
        title: "LLMs.txt Generator",
        href: "/free-tools/llms-txt-generator",
      },
      {
        title: "AI SEO & GEO Glossary",
        href: "/glossary",
      },
    ],
  },
  {
    group: "Blog",
    items: [
      {
        title: "What Is Generative Engine Optimization (GEO)?",
        href: "/blog/what-is-generative-engine-optimization-geo",
      },
      {
        title: "Why You're Invisible in AI Search",
        href: "/blog/why-youre-invisible-in-ai-search",
      },
      {
        title: "LLM.txt: Securing Your Brand's Future in AI Search",
        href: "/blog/how-to-use-llmtxt-for-optimizing-for-ai-search",
      },
      {
        title: "How to Use LLM.txt for Optimizing for AI Search",
        href: "/blog/how-to-use-llmtxt-for-optimizing-for-ai-search",
      },
      // {
      //   title: "Why Generative Engine Optimization (GEO) Matters More Than Ever",
      //   href: "/blog/why-generative-engine-optimization-geo-matters-more-than-ever",
      // },
    ],
  },
];

export default function FooterSection() {
  return (
    <footer className="pt-20 relative">
      <div className="mx-auto max-w-5xl px-6">
        <div className="grid gap-12 md:grid-cols-6">
          <div className="md:col-span-2">
            <Link href="/" aria-label="go home" className="block size-fit">
              <Image src="/logo.svg" alt="logo" width={180} height={140} />
            </Link>
            <p className="mt-4 text-sm text-muted-foreground/80 max-w-sm">
              Monitor and optimize your brand's presence in AI search engines like ChatGPT, Claude, and Perplexity.
            </p>

            <div className="mt-6 flex items-center gap-2 text-sm">
              <div className="flex items-center gap-2 bg-gray-100 border border-gray-200 rounded-md px-2 py-1">
                <div className="h-2 w-2 rounded-full bg-green-500 animate-pulse" />
                <span className="text-muted-foreground text-xs">All systems operational</span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2 sm:grid-cols-4 md:col-span-4">
            {links.map((link, index) => (
              <div key={index} className="space-y-4 text-sm">
                <span className="block font-medium">{link.group}</span>
                {link.items.map((item, index) => (
                  <Link
                    key={index}
                    href={item.href}
                    className="text-muted-foreground hover:text-primary block duration-150"
                    {...(item.href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  >
                    <span className="line-clamp-1">{item.title}</span>
                  </Link>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="mt-12 flex flex-wrap items-end justify-between gap-6 border-t py-6">
          <span className="text-muted-foreground order-last block text-center text-xs md:order-first">
            © {new Date().getFullYear()} Promptwatch B.V. All rights reserved | promptwatch.com
            <span className="mx-1.5">·</span>
            <Link href="/privacy-policy" className="hover:text-primary">
              Privacy Policy
            </Link>
            <span className="mx-1.5">·</span>
            <Link href="/terms-and-conditions" className="hover:text-primary">
              Terms of Service
            </Link>
            <span className="mx-1.5">·</span>
            <Link href="/contact-us" className="hover:text-primary">
              Contact Us
            </Link>
          </span>
          <div className="order-first flex flex-wrap justify-center gap-6 text-sm md:order-last">
            <Link
              href="https://x.com/promptwatchcom"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X/Twitter"
              className="text-muted-foreground hover:text-primary block"
            >
              <svg className="size-6" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M10.488 14.651L15.25 21h7l-7.858-10.478L20.93 3h-2.65l-5.117 5.886L8.75 3h-7l7.51 10.015L2.32 21h2.65zM16.25 19L5.75 5h2l10.5 14z"
                />
              </svg>
            </Link>
            <Link
              href="https://www.linkedin.com/company/promptwatch"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="text-muted-foreground hover:text-primary block"
            >
              <svg className="size-6" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93zM6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37z"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
